// removed by extract-text-webpack-plugin
module.exports = {"container":"src-pages----privacy-module---container---10UiJ","contentContainer":"src-pages----privacy-module---contentContainer---LaTbV","topBack":"src-pages----privacy-module---topBack---1F4k4"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/privacy.module.css
// module id = 418
// module chunks = 915738553496